export default function reducer(state = {
  processed: false,
  errors: {},
}, action) {
  switch (action.type) {
    case 'DELETE_LOGOUT_PENDING': {
      return {...state};
    }
    case 'DELETE_LOGOUT_FULFILLED': {
      return {
        ...state,
        processed: true,
      };
    }
    case 'DELETE_LOGOUT_REJECTED': {
      return {
        ...state, errors: action.payLoad
      };
    }
    default:
  }

  return {...state};
}
